module.exports = __webpack_public_path__ + "static/media/map-marker-check.2c94430f.svg";